import { ProductComparisonData, ProductModel, BaseFeature } from './types';

// ویژگی‌های پایه برای ردیاب‌ها
const trackerBaseFeatures: BaseFeature[] = [
    {
        feature: "ارتباط سلولی (Comm.)",
        description: "پشتیبانی از شبکه‌های ارتباطی مانند 4G برای اتصال و ارتباط بی‌وقفه",
    },
    {
        feature: "GPS",
        description: "مکان‌یابی لحظه‌ای با دقت بالا برای ردیابی موقعیت",
    },
    {
        feature: "گواهی ضد آب",
        description: "استاندارد مقاومت در برابر نفوذ آب برای استفاده ایمن در شرایط مرطوب",
    },
    {
        feature: "ظرفیت باتری (mAh)",
        description: "میزان ظرفیت باتری برای تعیین طول عمر شارژ و دوام استفاده",
    },
    {
        feature: "وزن",
        description: "وزن دستگاه برای راحتی در پوشیدن مداوم بدون احساس سنگینی",
    },
    {
        feature: "قابلیت تماس صوتی",
        description: "امکان برقراری تماس صوتی میان دستگاه و سرپرست برای برقراری ارتباط فوری",
    },
    {
        feature: "دکمه اضطراری (SoS Button)",
        description: "ارسال سیگنال هشدار به مخاطب‌های از پیش تعریف‌شده در مواقع اضطراری",
    },
    {
        feature: "دوربین",
        description: "امکان ثبت تصویر و تماس ویدئویی برای بررسی تصویری محیط یا کودک",
    },
    {
        feature: "رنگ‌بندی",
        description: "تنوع رنگ‌های قابل انتخاب برای سلیقه‌ها و اولویت‌های مختلف",
    },
];

// محصولات دسته ردیاب
const trackers: ProductModel[] = [
    {
        id: "tracker-EVT-P10",
        title: "EVT-P10",
        icon: "/media/products/trackers/tracker1.webp",
        colorClass: "from-orange-200 to-orange-300", // رنگ نارنجی برای دسته ردیاب
        category: "tracker",
        features: [
            { feature: "ارتباط سلولی (Comm.)", value: "4G" },
            { feature: "GPS", value: true },
            { feature: "گواهی ضد آب", value: "IPX7" },
            { feature: "ظرفیت باتری (mAh)", value: "500 mAh" },
            { feature: "وزن", value: "55 گرم" },
            { feature: "قابلیت تماس صوتی", value: false },
            { feature: "دکمه اضطراری (SoS Button)", value: false },
            { feature: "دوربین", value: true },
            { feature: "رنگ‌بندی", value: "Black" },
        ],
    },
    {
        id: "tracker-EVT-P50",
        title: "EVT-P50",
        icon: "/media/products/trackers/tracker2.webp",
        colorClass: "from-orange-200 to-orange-300",
        category: "tracker",
        features: [
            { feature: "ارتباط سلولی (Comm.)", value: "4G" },
            { feature: "GPS", value: true },
            { feature: "گواهی ضد آب", value: "-" },
            { feature: "ظرفیت باتری (mAh)", value: "1000 mAh" },
            { feature: "وزن", value: "40 گرم" },
            { feature: "قابلیت تماس صوتی", value: true },
            { feature: "دکمه اضطراری (SoS Button)", value: true },
            { feature: "دوربین", value: false },
            { feature: "رنگ‌بندی", value: "Black" },
        ],
    },
    {
        id: "tracker-EVT-P20",
        title: "EVT-P20",
        icon: "/media/products/trackers/tracker3.webp",
        colorClass: "from-orange-200 to-orange-300",
        category: "tracker",
        features: [
            { feature: "ارتباط سلولی (Comm.)", value: "4G" },
            { feature: "GPS", value: true },
            { feature: "گواهی ضد آب", value: "IP67" },
            { feature: "ظرفیت باتری (mAh)", value: "900 mAh" },
            { feature: "وزن", value: "36 گرم" },
            { feature: "قابلیت تماس صوتی", value: false },
            { feature: "دکمه اضطراری (SoS Button)", value: false },
            { feature: "دوربین", value: false },
            { feature: "رنگ‌بندی", value: "Black" },
        ],
    },
    {
        id: "tracker-EVT-P100",
        title: "EVT-P100",
        icon: "/media/products/trackers/tracker4.webp",
        colorClass: "from-orange-200 to-orange-300",
        category: "tracker",
        features: [
            { feature: "ارتباط سلولی (Comm.)", value: "4G" },
            { feature: "GPS", value: true },
            { feature: "گواهی ضد آب", value: "-" },
            { feature: "ظرفیت باتری (mAh)", value: "5000 mAh" },
            { feature: "وزن", value: "200 گرم" },
            { feature: "قابلیت تماس صوتی", value: false },
            { feature: "دکمه اضطراری (SoS Button)", value: false },
            { feature: "دوربین", value: false },
            { feature: "رنگ‌بندی", value: "Black" },
        ],
    },
    {
        id: "tracker-EVT-P07",
        title: "EVT-P07",
        icon: "/media/products/trackers/tracker5.webp",
        colorClass: "from-orange-200 to-orange-300",
        category: "tracker",
        features: [
            { feature: "ارتباط سلولی (Comm.)", value: "4G" },
            { feature: "GPS", value: true },
            { feature: "گواهی ضد آب", value: "IP65" },
            { feature: "ظرفیت باتری (mAh)", value: "600 mAh" },
            { feature: "وزن", value: "42 گرم" },
            { feature: "قابلیت تماس صوتی", value: false },
            { feature: "دکمه اضطراری (SoS Button)", value: true },
            { feature: "دوربین", value: false },
            { feature: "رنگ‌بندی", value: "Black" },
        ],
    },
];

// ترکیب همه محصولات
const allTrackers = [...trackers];

// داده‌های نهایی برای کامپوننت مقایسه
export const trackerData: ProductComparisonData = {
    baseFeatures: trackerBaseFeatures,
    categories: [
        {
            id: "all",
            label: "همه ردیاب‌ها",
            products: allTrackers,
        },
    ],
    allProducts: allTrackers,
};